<div class="d-flex flex-column justify-content-between h-100 notFoundPage">
  <img [id]="logoParams.logoId" [src]="logoParams.logoUrl" [alt]="logoParams.logoAltText">
  <section class="d-flex flex-column h-100 notFoundBody">
    <header class="text-center">
      <div class="notFoundTitle" [innerHTML]="title"></div>
    </header>
    <article class="text-center notFoundMessage" [innerHTML]="message"></article>
    @if (isZB) {
      <a class="d-block ps-1 backToZanerBloserLink text-link"
      [attr.href]="zbLink">Return to myzbportal.com</a>
    }
  </section>
</div>
